<template>
  <li v-if='checkPrice() === true' class="product">
    <div class="variants" v-bind:class="'id-' + item.id">

      <carousel :activePage="item.col_sel" :navigationEnabled="false">
        <slide v-bind:key="key" v-for="(color,key) in item.colors" v-bind:class="key.replace(' ', '-')">
          <a :href="createLink(color)">
            <div class="photo" v-bind:style="generateVariantPhotoName(color)"></div>
          </a>
        </slide>
      </carousel>

      <ul class='colors'>
        <li v-bind:key="key" v-for="(color,key) in item.colors" v-bind:class="key.replace(' ', '-')">
          <div v-bind:title='color.color_name' class='color icon'
               v-bind:style="{backgroundColor: '#' + color.main_color_hex}"
               v-on:click="switchCarouselToColor(key)">
          </div>
        </li>
      </ul><!-- colors -->

      <h3 class='model' v-html="getModelName()"></h3>
      <p class='price' v-if='parseInt(item.sell_price) > 0'
         v-html="$options.filters.full_price(item.sell_price)"></p>
        
      <div class="installment-item-info">{{((Math.round(parseInt(item.sell_price *100)/useInstallment)  ) / 100.0).toFixed(2)}} PLN x {{useInstallment}} RAT 0%</div>
      
    </div><!-- variants -->

  </li>
</template>

<script>
import Carousel from './../Carousel/Carousel.vue'
import Slide from './../Carousel/Slide.vue'

export default {
  name: 'item',
  props: {
    product: Object
  },
  data () {
    return {
      colorIndex: {},
      item: this.product,
      useInstallment: 10
    }
  },

  components: {Carousel, Slide},
  created: function () {
    if (typeof (this.item.colors) === 'object') {
      let that = this
      let i = 0
      _.forEach(this.product.colors, (color, colorId) => {
        that.colorIndex[colorId] = i++
      })
    }
    this.$bus.$on('changeOne',(data)=>{this.useInstallment=data})
    this.$bus.$on('changeTwo',(data)=>{this.useInstallment=data})
    this.$bus.$on('changeThree',(data)=>{this.useInstallment=data})
  },
  methods: {
    checkPrice(){
      if(parseInt(this.item.sell_price) > 5998 && this.useInstallment === 30){
        return true;
      }
      else if(parseInt(this.item.sell_price) > 2998 && this.useInstallment === 20){
        return true;
      }
      else if( this.useInstallment === 10){
        return true;
      }
    },
    createLink (color) {
      let link = env.baseUrl;
      link += window.translations[(this.item.type === 'b') ? 'rt_bike' : 'rt_accessory'];
      link += '/';
      link += this.item.internal_name.toLowerCase();
      link += '/';
      link += color.base_name;
      return link;
    },

    getModelName () {
      if (this.item.type === 'b') {
        return this.$options.filters.bike_name(this.item.name, this.item.gender)
      } else return this.item.name
    },
    /**
     * Ustanawia ścieżkę do pliku ze zdjęciem
     * @param {*} color
     */
    generateVariantPhotoName (color) {
      let style = 'background-image: url('
      style += env.baseUrl +
        'photos/styles/list/' +
        env.collection +
        '/' + (this.item.type === 'b' ? 'bikes' : 'accessories') + '/legrand_' +
        color.photo_color.toLowerCase() +
        (color.is_glossy === '1' ? '_polysk' : '_mat') +
        '.png'
      style += ');'
      return style
    }, // generateVariantPhotoName

    // przestawianie zdjęcia karuzeli na wybrany kolor
    switchCarouselToColor (colorId) {
      this.item.col_sel = this.colorIndex[colorId]
    }, // switchCarouselToColor

    pageChanged (page) {
      this.item.col_sel = page
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/Products/ItemInstallment.vue